'use client';

import { mdiEye, mdiEyeOff } from '@mdi/js';
import Icon from '@mdi/react';
import { useState } from 'react';

import BasicInput from '@/components/basics/BasicInput';
import { BasicInputProps } from '@/components/basics/BasicInput';

export type FormPasswordProps = BasicInputProps & { errorMessages?: string[] };
export default function FormPassword(props: FormPasswordProps) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleToggleVisibility = (isVisible: boolean) => {
    setIsPasswordVisible(isVisible);
  };

  const hasError = props.errorMessages && props.errorMessages.length > 0;

  return (
    <div className="flex flex-col">
      <BasicInput
        {...props}
        endContent={
          <button
            className="focus:outline-none"
            type="button"
            onClick={() => {
              handleToggleVisibility(!isPasswordVisible);
            }}
          >
            {isPasswordVisible ? (
              <Icon className="pointer-events-none text-2xl text-default-400" path={mdiEyeOff} size={1} />
            ) : (
              <Icon className="pointer-events-none text-2xl text-default-400" path={mdiEye} size={1} />
            )}
          </button>
        }
        type={isPasswordVisible ? 'text' : 'password'}
        isInvalid={hasError}
      />
      {hasError && props.errorMessages && (
        <div className="mt-2 flex flex-col gap-1">
          {props.errorMessages.map((error, index) => (
            <div key={index} className="text-xs text-danger">
              {error}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
